// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"0b6a8aba","61":"e62bf062","554":"77eb6c7d","563":"9d4b55a6","721":"50e83289","733":"ac13f4ea","787":"97243eeb","931":"b7bb1ac8"}[chunkId] + ".chunk.js";
};